// extracted by mini-css-extract-plugin
export default {"title":"hTy18eog","desktop":"desktop"};